import React from 'react';
import { DialogContent, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import BaseModal from '../BaseModal/BaseModal';
import SidebarTabs from '../SidebarTabs/SidebarTabs';
import ModalFooter from '../ModalFooter/ModalFooter';

import './DeviceconfigModal.css';

interface Props {
  open: boolean;
  setOpen: (val: boolean) => void;
  deviceName?: string;
  cancelText?: string;
  saveText?: string;
  onSave?: () => void;
  onCancel?: () => void;
  tabLabels: string[]; 
  activeTabIndex: number; 
  onTabSwitch: (label: string, index: number) => void;  
  renderTabContent: (index: number) => JSX.Element | null;
  showOnlineStatus?: boolean;  
  onlineStatusText?: string;
  lastSeen?: string;
  disableSave?: boolean;
  showRefreshIcon?: boolean;
  setRefreshIconClicked?: any,
  refreshIconClicked?: any,
  setRefreshTrigger?: any,
  onConnectToEdge?: any,
  isEssential?: boolean,
  disabledTabs?:number[];
  showOnlineOffline?: boolean
  showKonnectStatusWithHeader?: boolean;
  footer?: boolean;
  syncStatus?: string;
  showSyncStatus?: boolean;
  width?: string;
  height?: any;
}

const DeviceConfigModal: React.FC<Props> = ({
  open,
  setOpen,
  deviceName = 'Device',
  cancelText,
  saveText,
  onSave,
  onCancel,
  tabLabels,
  activeTabIndex,
  onTabSwitch,
  renderTabContent,
  showOnlineStatus,
  onlineStatusText,
  lastSeen,
  disableSave,
  showRefreshIcon,
  setRefreshIconClicked,
  refreshIconClicked,
  setRefreshTrigger,
  onConnectToEdge,
  isEssential,
  disabledTabs,
  showOnlineOffline,
  showKonnectStatusWithHeader,
  footer = false,
  syncStatus,
  showSyncStatus,
  width,
  height="480px"
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClose = () => {
    onCancel?.();
  };

  const handleSave = () => {
    onSave?.();
  };

  const handleTabChange = (_: any, index: number) => {
    onTabSwitch(tabLabels[index], index);
  };

  return (
    <BaseModal open={open} onClose={handleClose} title={deviceName} height={height} width={width} showOnlineStatus={showOnlineStatus}  onlineStatusText={onlineStatusText} lastSeen={lastSeen} showRefreshIcon={showRefreshIcon} setRefreshIconClicked={setRefreshIconClicked} refreshIconClicked={refreshIconClicked} setRefreshTrigger={setRefreshTrigger} onConnectToEdge={onConnectToEdge} isEssential={isEssential} showOnlineOffline={showOnlineOffline} showKonnectStatusWithHeader={showKonnectStatusWithHeader} syncStatus={syncStatus} showSyncStatus={showSyncStatus}>
      <DialogContent className="modal-content-wrapper">
        <Box
          className="modal-body"
          style={{ flexDirection: isSmallScreen ? 'column' : 'row' }}
        >
          <SidebarTabs
            tabs={tabLabels}
            activeTab={activeTabIndex}
            onChange={handleTabChange}
            isHorizontal={isSmallScreen}
            disabledTabs={disabledTabs}
          />
          <Box className="modal-content">
            <Box className="modal-tab-panel">{renderTabContent(activeTabIndex)}</Box>
            {(footer) && <ModalFooter
              onClose={handleClose}
              onSave={handleSave}
              cancelText={cancelText}
              saveText={saveText}
              disableSave={disableSave}
            />}
          </Box>
        </Box>
      </DialogContent>
    </BaseModal>
  );
}

export default DeviceConfigModal;